import {
	HTTPClient,
	UserFavoritesResponseModel,
} from "@gp/offer/dist/types/stores/favorites/types";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class FavoritesApiService implements HTTPClient {
	baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/user-favorite-user-favorite-groups/user-settings/`;
	}

	getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	async get(): Promise<UserFavoritesResponseModel> {
		const context = getApiRequestContext();
		return await httpClient.get(
			`${this.baseUrl(context)}`,
			this.getRequestHeaders(context)
		);
	}

	async update(
		data: UserFavoritesResponseModel
	): Promise<UserFavoritesResponseModel> {
		const context = getApiRequestContext();

		return await httpClient.post(
			`${this.baseUrl(context)}`,
			JSON.stringify(data),
			this.getRequestHeaders(context)
		);
	}

	async delete(
		data: UserFavoritesResponseModel
	): Promise<UserFavoritesResponseModel> {
		const context = getApiRequestContext();

		return await httpClient.delete(
			`${this.baseUrl(context)}`,
			this.getRequestHeaders(context),
			{ body: JSON.stringify(data) }
		);
	}
}
